import { useRouter } from "next/router";
import { timeAgo } from "~/utils/app";
const ApplicationItem = (props) => {
  const router = useRouter();
  const { post } = props.application.opening;

  return (
    <div className={`item-wrapper ${props.className}`}>
      <div className="item-header">
        <div className="top">
          <div
            className="title"
            onClick={() => {
              router.push(
                `/tposts/${props.application.opening.eleduck_post_id}`
              );
            }}
          >
            <span>
              【{post.number}】{post.full_title || post.title}
            </span>
          </div>
          <div className="update-at">
            <span className="mx-5">上次更新时间:</span>
            {timeAgo(props.application.last_operated_at)}
          </div>
        </div>
        <div className="status">{props.application.status_title}</div>
      </div>
    </div>
  );
};
export default ApplicationItem;
